module.exports = __webpack_public_path__ + "static/media/first-slide.2c60a3e2.webp";